import React, { useEffect, ReactElement } from 'react';

import { yearRangeArr } from '../DatePickerUtil';

import {
  YearSelectionContainer,
  Year,
  yearHeight,
  yearLineHeight,
  yearsContainerHeight
} from './YearView.styles';

interface YearViewProps {
  selectedYear: number;
  setCurrentYear: Function;
}

const YearView = ({
  selectedYear,
  setCurrentYear
}: YearViewProps): ReactElement => {
  useEffect(() => {
    const posY: number =
      yearRangeArr.indexOf(selectedYear) * yearHeight -
      yearsContainerHeight / 2 +
      yearLineHeight / 2;
    const yearscontainer = window.document.getElementById('yearscontainer');
    if (yearscontainer) {
      yearscontainer.scrollTop = posY;
    }
  }, []);

  return (
    <YearSelectionContainer id="yearscontainer">
      {yearRangeArr.map(year => (
        <Year
          selected={year === selectedYear}
          key={year}
          onClick={() => setCurrentYear(year)}
        >
          {year}
        </Year>
      ))}
    </YearSelectionContainer>
  );
};

export default YearView;
